export default "__VITE_ASSET__Dw1haLf7__"